const RELOADED_AT_KEY = "stale-build-reloaded-at";
const RELOAD_COOLDOWN_MS = 10_000;

export function reloadOnce() {
  const reloadedAt = Number(sessionStorage.getItem(RELOADED_AT_KEY));

  if (reloadedAt && Date.now() - reloadedAt < RELOAD_COOLDOWN_MS) {
    return false;
  }

  sessionStorage.setItem(RELOADED_AT_KEY, String(Date.now()));
  window.location.reload();

  return true;
}
